<template>
    <el-dialog class="el-dialogs" :title="title" :close-on-click-modal="false"
               :visible.sync="visible" :fullscreen="true">
        <div class="content" v-show="step == 0">
            <el-row>
                <el-col :span="10" class="seleTb">
                    <div class="flex_b_c">
                        <div class="minTitle">资源分组</div>
                        <el-input size="mini" style="width: 200px" suffix-icon="el-icon-search"
                                  v-model.trim="leftKeyWorld" maxlength="20"
                                  placeholder="请输入关键字(限20字)"></el-input>
                    </div>
                    <el-tree
                            style="height:calc(100% - 43px);overflow-y: auto"
                            ref="tree"
                            :data="allDataList"
                            show-checkbox
                            node-key="id"
                            :check-strictly="true"
                            default-expand-all
                            :filter-node-method="filterNode"
                            :props="defaultProps">
                        <template class="custom-tree-node" slot-scope="{ node, data }">
                            <div class="flex_l_c">
                                <div class="omit" style="width: 150px;padding-right: 20px">{{ data.groupingName }}</div>
                                <div>资源数: {{ data.resourcesNum }}条</div>
                            </div>
                        </template>
                    </el-tree>
                </el-col>
                <el-col :span="4" class="text_center seleMiddle">
                    <div>
                        <el-button size="mini" type="primary" @click="moveData('left')">添加分组 <i
                                class="el-icon-arrow-right"></i></el-button>
                    </div>
                    <div style="margin-top: 30px">
                        <el-button size="mini" icon="el-icon-arrow-left" @click="moveData('right')">取消分组</el-button>
                    </div>
                </el-col>
                <el-col :span="10" class="seleTb">
                    <div class="flex_b_c">
                        <div class="minTitle">已选分组</div>
                        <el-input size="mini" style="width: 200px" suffix-icon="el-icon-search"
                                  v-model.trim="rightKeyWorld" maxlength="20"
                                  placeholder="请输入关键字(限20字)"></el-input>
                    </div>
                    <el-table
                            :data="rightKeyWorld === '' ? rightDataList : searRightDataList"
                            size="small" height="calc(100% - 43px)"
                            class="table" border
                            ref="rightTable"
                            :row-key="'id'"
                            :tree-props="{children: 'aaaaaaa',}"
                            @selection-change="rightSelection"
                    >
                        <el-table-column :reserve-selection="true" type="selection" width="50"/>
                        <el-table-column prop="groupingName" label="分组名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="resourcesNum" sortable label="资源数"
                                         show-overflow-tooltip></el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <div class="flex_b_c magTop">
                <div>已选资源数：<span style="font-weight: bold">{{ selectList.length }}条</span></div>
                <el-button size="small" type="primary" @click="nextStep()">下一步</el-button>
            </div>
        </div>
        <div class="content" v-show="step == 1">
            <div class="flex_b_c">
                <div class="minTitle">已选资源</div>
                <div>
                    <el-input size="mini" style="width: 200px;margin-right: 10px" suffix-icon="el-icon-search"
                              v-model.trim="resourcesKeyWorld" maxlength="20" clearable
                              placeholder="请输入关键字(限20字)"></el-input>
                    <el-button type="primary" @click="searchResources()" size="small" icon="el-icon-search">查询
                    </el-button>
                </div>
            </div>
            <el-table
                    :data="searchSelectList"
                    size="small" height="300px"
                    class="table" border
                    ref="resourceTable"
                    :row-key="'id'"
            >
                <el-table-column v-for="(item, index) in tabHead" :key="index"
                                 :prop="item.basicCode"
                                 :label="item.basicRename"
                                 show-overflow-tooltip v-if="item.disabled == '0'">
                    <template slot-scope="scope">
                        <span>{{ listDataFormat(item, scope.row.jsonData[item.basicCode]) }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="80px" fixed="right" label="操作">
                    <template slot-scope="{row,$index}">
                        <el-button type="text" size="small" @click="deleteData(row,$index)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="flex_b_c magTop">
                <div class="minTitle">已选分组</div>
                <div>
                    <el-input size="mini" style="width: 200px;margin-right: 10px" suffix-icon="el-icon-search"
                              v-model.trim="subjectWorld" maxlength="20" clearable
                              placeholder="请输入关键字(限20字)"></el-input>
                    <el-button type="primary" @click="searchSubject()" size="small" icon="el-icon-search">查询
                    </el-button>
                </div>
            </div>
            <div class="subjectCont magTop">
                <el-tag
                        v-for="tag in searchSubjectList"
                        :key="tag.id"
                        closable @close="deleteDataSeleSubject(tag)"
                >
                    {{ tag.groupingName }}
                </el-tag>
            </div>
            <div class="text_right">
                <el-button @click="step = 0;title = '选择分组'" size="small">上一步</el-button>
                <el-button type="primary" @click="submit()" size="small" v-no-more-click>提交</el-button>
            </div>
        </div>
        <div class="content" v-show="step == 2">
            <el-result icon="success" title="资源分组设置成功"
                       :subTitle="`已成功为 ${selectList.length} 条资源添加了 ${rightDataList.length} 个分组。`">
                <template slot="extra">
                    <el-button type="primary" size="medium" @click="visible = false">完成</el-button>
                </template>
            </el-result>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: "changeGrouping",
    data() {
        return {
            title: '选择分组',
            visible: false,
            tabHead: [],
            selectList: [],//选中的数据
            searchSelectList: [],
            step: 0,

            defaultProps: {
                children: 'children',
                label: 'groupingName'
            },
            leftKeyWorld: '',
            rightKeyWorld: '',
            allDataList: [],//所有数据
            leftDataList: [],//未选择的数据
            rightDataList: [],//已选择的数据
            searLeftDataList: [],//检索未选择数据是的表
            searRightDataList: [],//检索已选择数据是的表
            leftDataListSelect: [],//左边选中的数据
            rightDataListSelect: [],//右边选中的数据

            resourcesKeyWorld: '',
            subjectWorld: '',
            searchSubjectList: [], //资源分组信息确认 分组的搜索
        }
    },

    watch: {
        leftKeyWorld() {
            this.$refs.tree.filter(this.leftKeyWorld);
        },

        rightKeyWorld() {
            this.$refs.rightTable.clearSelection()
            this.searRightDataList = this.rightDataList.filter(item => {
                return item.groupingName.indexOf(this.rightKeyWorld) != -1
            })
        },
    },

    methods: {
        //tabHead:元数据表头  selectList选中的资源
        init(tabHead, selectList) {
            this.visible = true
            this.title = '选择分组'
            this.selectList = JSON.parse(JSON.stringify(selectList))
            this.tabHead = tabHead
            this.leftKeyWorld = ''
            this.rightKeyWorld = ''
            this.resourcesKeyWorld = ''
            this.subjectWorld = ''
            this.rightDataList = []
            this.step = 0
            this.getAllSpecial()
        },

        //获取所有分组
        getAllSpecial() {
            this.$axios(this.api.academic.groupingQueryList).then(data => {
                if (data.status) {
                    console.log(data)
                    this.allDataList = data.data
                }
            })
        },

        filterNode(value, data) {
            if (!value) return true;
            return data.groupingName.indexOf(value) !== -1;
        },

        //左右选择时的数据筛选
        filterSeleData() {
            this.leftDataList = []
            this.allDataList.forEach(item => {
                let reapet = this.rightDataList.filter(item2 => {
                    return item2.id == item.id
                })
                if (reapet.length == 0) {
                    this.leftDataList.push(item)
                }
            })
            this.searLeftDataList = this.leftDataList.filter(item => {
                return item.groupingName.indexOf(this.leftKeyWorld) != -1
            })
            this.searRightDataList = this.rightDataList.filter(item => {
                return item.groupingName.indexOf(this.rightKeyWorld) != -1
            })
        },

        //左边表格勾选数据
        leftSelection(val) {
            this.leftDataListSelect = val
        },

        //右边表格勾选数据
        rightSelection(val) {
            this.rightDataListSelect = val
        },

        //移动数据 left移动左边的数据 right移动右边的数据
        moveData(name) {
            if (name == 'left') {
                this.rightDataList = this.$refs.tree.getCheckedNodes()
            } else {
                if (this.rightDataListSelect.length == 0) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                this.rightDataListSelect.forEach(item1 => {
                    this.$refs.tree.setChecked(item1.id, false)
                    this.rightDataList = this.rightDataList.filter(item2 => {
                        return item2.id != item1.id
                    })
                })
                this.$refs.rightTable.clearSelection()
            }
        },

        //下一步
        nextStep() {
            if (this.step == 0) {
                if (this.rightDataList.length == 0) {
                    this.$message.warning('请至少选择一条分组')
                    return
                }
                this.title = '资源分组信息确认'
                this.step++;
                this.searchSubject()
                this.searchResources()
            }
        },

        //搜索
        searchResources() {
            let ids = this.selectList.map(item=>{
                return item.id
            })
            if (this.resourcesKeyWorld !== '') {
                this.$axios(this.api.metadata.metadatadataQueryMetadataDataKeyWord + '?keyword=' + this.resourcesKeyWorld, ids, 'post').then(data => {
                    if (data && data.status) {
                        this.searchSelectList = data.data
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.searchSelectList = this.selectList
            }
        },

        //删除资源
        deleteData(row,index) {
            this.$confirm(`您是否确认删除该资源?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.selectList.splice(index,1)
            })
        },

        //删除已选分组
        deleteDataSeleSubject(row) {
            this.$confirm(`您是否确认删除该分组?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.rightDataList = this.rightDataList.filter(item => {
                    if (item.id == row.id){
                        this.$refs.tree.setChecked(item.id, false)
                    }
                    return item.id != row.id
                })
                this.filterSeleData()
                this.searchSubject()
            })
        },

        //分组搜索
        searchSubject() {
            if (this.subjectWorld === '') {
                this.searchSubjectList = this.rightDataList
            } else {
                this.searchSubjectList = this.rightDataList.filter(item => {
                    return item.groupingName.indexOf(this.subjectWorld) != -1
                })
            }
        },

        //保存
        submit() {
            if (this.selectList.length == 0) {
                this.$message.warning('已选资源为空')
                return
            }
            if (this.rightDataList.length == 0) {
                this.$message.warning('已选分组为空')
                return
            }
            let resourcesIdList = this.selectList.map(item => {
                return item.id
            })
            let thematicIdList = this.rightDataList.map(item => {
                return item.id
            })
            this.$confirm(`您是否确认添加选中的分组?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.relevancedataBatchSave, {
                    dataType: 1,
                    resourcesIdList,
                    thematicIdList,
                    basicDataId:this.selectList[0].basicDataId,
                }, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success(`提交成功`)
                        this.$emit('refresh')
                        this.step++
                        this.title = '资源分组设置结果'
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.el-dialogs::v-deep .el-dialog__body {
  height: auto !important;
  max-height: none !important;
}

.content {
  padding: 20px 50px 0;
}

.seleTb {
  height: 80vh;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #DCDCDC;
}

.minTitle {
  font-weight: 600;
}

.table {
  margin-top: 15px;
}

.seleMiddle {
  margin-top: 13%;
}

.magTop {
  margin-top: 20px;
}

.subjectCont {
  height: 160px;
  overflow-y: auto;
}
</style>